<template>
  <div class="co-layout">

    <div v-show='!isPC' class="h5-home-layout">
      <div class="header">
        <img class="header-icon" src="@/assets/hder_icon.png">
      </div>
      <div id="id-h5-home-layout" class="content">

        <div class="info-show-layout">
          <div  class="info-show-layout-pro">
            <img class="header_info-style" src="@/assets/header_info.png">
          </div>
          <div class="bg-cloud-layout-p">
            <div class="bg-cloud-layout">
              <img alt="Cloud 1" class="cloud cloud-syt1" src="@/assets/h5_cloud_1.png">
              <img alt="Cloud 2" class="cloud cloud-syt2" src="@/assets/h5_cloud_2.png">
              <img alt="Cloud 3" class="cloud cloud-syt3" src="@/assets/h5_cloud_3.png">
            </div>
          </div>
          <div v-if="donateListShow" class="donation-information-layout">
            <van-swipe height="35" :autoplay="1500" vertical :loop="true" :show-indicators='false'>
              <van-swipe-item v-for="(item,index) in donateList" :key="index">
                <div class="donation-information-name">{{ item.name }} <span class="infos">捐赠了{{ item.value }}元 </span></div>
              </van-swipe-item>
            </van-swipe>
          </div>

          <div @click="jonUs()" style="width: 6rem;position: fixed;top:32rem;right: 1rem;z-index: 100" class="box-anims">
            <MyLottie :options="defaultOptionsHome1" class="lottie-body" v-on:animCreated="handleAnimation1"/>
          </div>
          <div v-if="isWeChatBrowser()"  style="width: 6rem;height:6rem;position: fixed;top:32rem;right: 1rem;z-index: 1000"  id="id-open-jump-s">

          </div>

        </div>
        <div style="padding-top: 1rem;text-align: left">
          <img style="height:6.5rem ;" src="@/assets/content_1_1.png">
        </div>

        <div class="section-title">
          <img class="section-title-img" src="@/assets/title_1.png">
        </div>
        <div class="swipe-layout">
          <my-swipe animTime="2100" :images="images"/>
        </div>
        <div class="section-title">
          <img class="section-title-img" src="@/assets/title_2.png">
        </div>
        <div class="swipe-layout">
          <my-swipe animTime="2000" :images="images1"/>
        </div>
        <H5NewView :lists="newList"></H5NewView>
        <!--        <img class="content-icon" src="@/assets/content_2.png">-->
        <img class="content-icon" src="@/assets/content_3.png">

        <div class="centered">

          <div @click="jonUs()" style="width: 14rem;" class="box-anims anim-bg1">
            <MyLottie :options="defaultOptionsHome" class="lottie-body" v-on:animCreated="handleAnimation"/>
          </div>
          <div v-if="isWeChatBrowser()"  class="open-stys" id="id-open-wx-apps">

          </div>
        </div>
        <div style="margin-top: 2rem" class="footer-link">
          <div @click="openUrl">粤ICP备18115042号-2</div>
          <div style="text-align: center;margin-top: 1rem">广州钛森数娱科技有限公司版权所有</div>
        </div>
      </div>

    </div>
    <div v-show='isPC'  class="pc-home-layout">
      <div class="bg-cloud-layout-p">
        <div class="bg-cloud-layout">
          <img alt="Cloud 1" class="cloud cloud-syt1" src="@/assets/cloud_1.png">
          <img alt="Cloud 2" class="cloud cloud-syt2" src="@/assets/cloud_2.png">
          <img alt="Cloud 3" class="cloud cloud-syt3" src="@/assets/cloud_3.png">
        </div>
      </div>
      <div class="pc-content-layout">
        <div class="logo-image-layout-p">
          <div class="logo-image-layout">
            <img class="pc-logo-sty" src="@/assets/pc_logo.png" @click="tabClick(0)">
            <img class="pc-logo-sty" src="@/assets/pc_right_title.png">
          </div>
        </div>

        <div class="tab-layout">
          <div class="tab-temds">
            <div v-for="(item, idx) in tabItems" :key="idx" class="tab-title-la">
              <img v-if="tabIndex === item.index " class="tab-select-star" src="@/assets/tab_select.png">
              <div :class="tabIndex === item.index ? 'tab-items-s' : 'tab-items'" @click="tabClick(item.index)">
                {{ item.label }}
              </div>
              <div v-if="idx < tabItems.length - 1" class="lines"/>
            </div>
          </div>
        </div>
        <div class="tab-content-layout">
          <div v-show="tabIndex === 4" class="content-layout">
            <div class="co-layout">
              <div class="time-layout">
                <div
                    v-for="(year, idx) in [2024, 2025]"
                    :key="year"
                    :class="seIndex === idx ? 'items-s' : 'items'"
                    @click="seClick(idx)"
                >
                  {{ year }}
                </div>
              </div>
              <div v-if="seIndex === 0">
                <div class="title-layout">
                  <div class="time">11月</div>
                  <div class="title">四川省凉山彝族自治区美姑县</div>
                  <div/>
                </div>
                <div class="images-layout">
                  <MyCarousel :images="images"/>
                </div>
              </div>
              <div v-if="seIndex === 1">
                <div class="title-layout">
                  <div class="time">5月</div>
                  <div class="title">四川省凉山彝族自治区佐戈依达村</div>
                  <div/>
                </div>
                <div class="images-layout">
                  <MyCarousel :images="images1"/>
                </div>
              </div>
            </div>
          </div>
          <div v-show="tabIndex === 0" class="content-layout">
            <img class="pc-tab-image" style="background: #00000000" src="@/assets/pc_img0.png">
          </div>
          <div v-show="tabIndex === 1" class="content-layout">
            <img class="pc-tab-image" src="@/assets/pc_img1.png">
          </div>
          <div v-show="tabIndex === 2" class="content-layout">
            <img class="pc-tab-image" src="@/assets/pc_img2.png">
          </div>
          <div v-show="tabIndex === 3" class="content-layout">
            <img class="pc-tab-image" src="@/assets/pc_img3.png">
<!--            <div  class="pc-open-stys" id="id-open-wx-apps-pc">-->

<!--            </div>-->
          </div>
          <div v-if="tabIndex === 5" class="content-layout">
            <div class="news-view">
              <div style="text-align: left" class="title-layout-new">
                <img style="height: 50px" src="@/assets/pc_news_title.png">
              </div>
              <PCNewView :lists="newList"></PCNewView>
            </div>
          </div>
        </div>
        <div class="footer-link pc">
          <div align="center" @click="openUrl">粤ICP备18115042号-2</div>
          <div style="text-align: center;margin-top: 20px">广州钛森数娱科技有限公司版权所有</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
// import VConsole from 'vconsole';
import MyLottie from "@/components/MyLottie.vue";
import imgPath1 from '@/assets/news/may_6.jpg';
import imgPath2 from '@/assets/news/may_1.jpg';
import imgPath3 from '@/assets/news/news_image1.jpeg';
import imgPath4 from '@/assets/news/may_7.jpg';
import imgPath5 from '@/assets/news/news_image2.jpg';
import imgPath6 from '@/assets/new3_img7.jpg';
import imgPath7 from '@/assets/new4_imag5.png';
import * as h_join from "@/assets/h_join.json";
import * as join_us from "@/assets/join_us.json";
import MySwipe from "@/components/MySwipe.vue";
import H5NewView from "@/components/H5NewView.vue";
import MyCarousel from "@/components/MyCarousel.vue";
import PCNewView from "@/components/PCNewView.vue";
import Axios from 'axios';
import 'animate.css';
export default {
  metaInfo: {
    title: '地平线计划',
    meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { hid: 'description', name: 'description', content: '超越极限的脚步，永不落山的公益' },
      { name: 'keywords', content: '地平线计划, 公益计划' },
      { name: 'og:type', content: 'article' },
      { name: 'og:title', content: '地平线计划' },
      { name: 'og:description', content: '超越极限的脚步，永不落山的公益' },
      { name: 'og:url', content: 'https://www.dipingxian.love' },
      { name: 'og:image', content: 'https://www.dipingxian.love/share_logo.png' },
      { name: 'baidu-site-verification', content: 'codeva-0oDkUgXrFn' },
    ]
  },

  components: {
    MySwipe:MySwipe,
    MyLottie: MyLottie,
    H5NewView:H5NewView,
    MyCarousel:MyCarousel,
    PCNewView:PCNewView,
  },
  data() {
    return {
      isPC: !/Android|iPhone|SymbianOS|Windows Phone|iPad|iPod/i.test(navigator.userAgent),
      html:'<wx-open-launch-weapp id="launch-btn" username="gh_3f146c2a1401@app" path="pages/yqj_v2/detail/main.html?id=3019527&parent2=mGDwEmnHQDJyj-ZSLECVTdfHSjQw4nY-SmviRc20O34&parent1=mGDwEmnHQDJyj-ZSLECVTdfHSjQw4nY-SmviRc20O34&did=250710204203906008&openview=&spmet=3367.3368.3375&et=share" @launch="handleLaunchFn" @error="handleErrorFn"><template><style>.btn { display: flex;align-items: center; }</style><button  class="btn">跳转小程序</button></template></wx-open-launch-weapp>',
      defaultOptionsHome: {
        animationData: join_us.default,
        autoplay: false,
        loop: false
      },
      defaultOptionsHome1: {
        animationData: h_join.default,
        autoplay: false,
        loop: false
      },
      donateListShow: false,
      donateList: [
        {
          "name": "孙凯",
          "value": 10000
        },
        {
          "name": "许建锋",
          "value": 5000
        },
        {
          "name": "Kevin",
          "value": 8000
        },
        {
          "name": "吴明",
          "value": 6666
        },
        {
          "name": "李坤",
          "value": 6666
        },
        {
          "name": "Jimmy",
          "value": 3000
        },
        {
          "name": "柏高纺织有限公司",
          "value": 5000
        },
        {
          "name": "柏顺酒店用品有限公司",
          "value": 5000
        },
        {
          "name": "汉和日用品有限公司",
          "value": 5000
        },
        {
          "name": "力浦交通照明有限公司",
          "value": 110067
        }
      ],
      anim: undefined,
      anim1: undefined,
      isWeChat: false,
      launchWeappHtml: '',
      aId: undefined,
      show: true,
      showUpJoin:true,
      showNews: false,
      showNews1: false,
      videoShow: false,
      videoShow1: false,
      seIndex: 0,
      tabIndex: 4,
      tabItems: [
        {label: '为爱前行', index: 4},
        {label: '新闻中心', index: 5},
        {label: '合作机构', index: 1},
        {label: '爱心企业', index: 2},
        {label: '加入我们', index: 3},
      ],
      images: Array.from({ length: 6 }, (_, i) => ({ src: require(`@/assets/image${i + 1}.jpg`) })),
      images1: Array.from({ length: 10 }, (_, i) => ({ src: require(`@/assets/may_${i + 1}.jpg`) })),
      newList: [
        {
          id: 1,
          title: '地平线计划”照亮佐戈依达村，公益行动温暖乡村',
          desc: ' 近日，一场洋溢温暖与希望的公益行动在四川省西昌市新桥镇佐戈依达村圆满收官。由“地平线计划”牵头，联合江苏力浦交通照明有限公司、江苏汉和日用品有限公司、扬州柏顺酒店用品有限公司、吴江柏高纺织有限公司及爱心人士李坤、吴明、孙凯、许剑锋，为佐戈依达 ',
          time: '',
          type: 1,
          imgUrl: imgPath1,
          pcURL: '',
          h5url: '/newDesc',
        },
        {
          id: 2,
          title: '灯暖凉山——记录大凉山村民生活改造实录',
          desc: '',
          time: '',
          type: 2,
          imgUrl: imgPath2,
          pcURL: '',
          h5url: 'https://mp.weixin.qq.com/s/yVUspuuO-L0A-FO2BGukZA'
        },
        {
          id: 3,
          title: '地平线计划——用脚步丈量公益，以行动点亮希望',
          desc: '我们是一群热爱运动、热衷公益的企业家和爱心人士，因共同的信念汇聚成“地平线计划”——超越极限的脚步，永不落山的公益。',
          time: '',
          type: 1,
          imgUrl: imgPath3,
          pcURL: '',
          h5url: '/newDesc1'
        },
        {
          id: 4,
          title: '大凉山的希望火种 ——直击塔哈村小学破茧之路',
          desc: '',
          time: '',
          type: 2,
          imgUrl: imgPath4,
          pcURL: '',
          h5url: 'https://mp.weixin.qq.com/s/kbOmlTTjqgwZ4o9QQVFarQ'
        },
        {
          id: 5,
          title: '从地平线到塔哈：一份早餐的温度',
          desc: '清晨的大凉山，薄雾还未完全散尽，塔哈村小学的厨房已飘出阵阵暖香。2025年6月2日，由“广州地平线爱心公益”捐赠的专项善款已落实到位（收款人：许定奎校长），化作了孩子们手中一份份珍贵的爱心早餐。',
          time: '',
          type: 1,
          imgUrl: imgPath5,
          pcURL: '',
          h5url: '/newDesc2',
        },
        {
          id: 6,
          title: '步履山海，恒久为爱：地平线计划2025-2026公益纪实',
          desc: '“地平线计划”的初衷是汇聚一群热爱运动、热衷公益的企业家和爱心人士发起，以“超越极限的脚步，永不落山的公益”为信念，将奔跑者的坚韧与公益行动相结合。将挑战自我、坚韧不拔的运动精神（如马拉松、戈壁挑战）转化为持久的公益力量。我们旨在通过“运动+公益”的独特模式，突破地域与资源的限制，携手点亮乡村、温暖教育、持续行动，如同追逐地平线一样，始终向着远方和希望前行，让温暖与光明持续照耀每一处需要的地方。',
          time: '',
          type: 1,
          imgUrl: imgPath6,
          pcURL: '',
          h5url: '/newDesc3',
        },
        {
          id: 7,
          title: '地平线计划爱心照亮深山之路：150盏太阳能路灯点亮甘洛县沙岱乡',
          desc: '“点亮乡村振兴路”公益项目由贵州省为爱黔行公益服务中心统筹实施，旨在通过捐赠太阳能路灯，改善偏远山区照明条件，提升村民生活品质，助力乡村振兴。项目受赠方为四川省甘洛县沙岱乡人民政府，路灯覆盖各布村、阿尺村、舍底村、磨子沟村、妮觉俄洛村共五个村落。',
          time: '',
          type: 1,
          imgUrl: imgPath7,
          pcURL: '',
          h5url: '/newDesc4',
        },
      ],
    };
  },
  mounted() {
     // new VConsole();
    var self = this;
    this.insertWeappLauncher(document.getElementById('id-open-wx-apps'))
    this.insertWeappLauncher(document.getElementById('id-open-jump-s'))
    this.initJsSDK();
    // this.loadWxSdk();
    this.shuffleArray(this.donateList);
    var list = [...this.donateList];
    this.donateList.push(...list);
    this.donateList.push(...list);
    this.donateList.push(...list);
    this.donateList.push(...list);
    this.donateListShow = true;

    setTimeout(() => {
      if(self.anim&&self.anim1){
        self.anim.play();
        self.anim1.play();
      }
    }, 200);
    window.addEventListener('scroll', function() {
      var scrollHeight = document.documentElement.scrollHeight;
      var clientHeight = window.innerHeight;
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop + clientHeight >= scrollHeight-100) {
        self.showUpJoin = false;
      } else {
        self.showUpJoin = true;
      }
    });


  },
  methods: {
    async  initJsSDK() {

      // var self = this
      const nonceStr = Math.random().toString(36).slice(2, 15)
      const timestamp = parseInt(new Date().getTime() / 1000)
      const url = window.location.href

      Axios.get("https://api.dipingxian.love/api/wx/signature?nonceStr="+nonceStr+"&timestamp="+timestamp+"&url="+url).then((data) => {
        // console.log('timestamp= ' + timestamp)
        // console.log('appId= ' + 'wx7802fd66865d6cca')
        // console.log('nonceStr= ' + nonceStr)
        // console.log('signature= ' + data.data.signature)
        // console.log('url= ' + url)
        wx.config({
          debug: false,
          appId: 'wx7802fd66865d6cca',
          timestamp: timestamp,
          nonceStr: nonceStr,
          signature: data.data.signature,
          jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage'],
        });

        // wx.config({
        //   debug: false, // 调试时可开启
        //   appId: 'wxef7ba8c3fda9ee99', // <!-- replace -->
        //   timestamp: 12312121, // 必填，填任意数字即可
        //   nonceStr: 'adbd', // 必填，填任意非空字符串即可
        //   signature: '111asdfasd', // 必填，填任意非空字符串即可
        //   jsApiList: ['hideOptionMenu'], // 必填，随意一个接口即可
        //   openTagList:['wx-open-launch-weapp'], // 填入打开小程序的开放标签名
        // })

        wx.ready(() => {

          const shareData = {
            title: "地平线计划",
            desc: "超越极限的脚步，永不落山的公益",
            link: url,
            imgUrl: "https://www.dipingxian.love/share_logo.png"
          };
          // wx.updateAppMessageShareData(shareData);
          // wx.updateTimelineShareData(shareData);
          wx.onMenuShareTimeline(shareData);
          wx.onMenuShareAppMessage(shareData);
          wx.config({
            debug: false, // 调试时可开启
            appId: 'wxef7ba8c3fda9ee99', // <!-- replace -->
            timestamp: 12312121, // 必填，填任意数字即可
            nonceStr: 'adbd', // 必填，填任意非空字符串即可
            signature: '111asdfasd', // 必填，填任意非空字符串即可
            jsApiList: ['hideOptionMenu'], // 必填，随意一个接口即可
            openTagList:['wx-open-launch-weapp'], // 填入打开小程序的开放标签名
          })

        });
        wx.error(function (res) {
          console.log(res)
          // alert('错误信息1：' + JSON.stringify(res))
        });
      });

    },

    // 判断是否是微信浏览器
    isWeChatBrowser() {
      return /MicroMessenger/i.test(navigator.userAgent)
    },

    // 动态插入 wx-open-launch-weapp 组件
    insertWeappLauncher(doc) {
      if(!this.isWeChatBrowser()){
        return;
      }
      const weappTag = document.createElement('wx-open-launch-weapp');
      weappTag.setAttribute('id', 'launch-btn');
      weappTag.setAttribute('username', 'gh_3f146c2a1401@app');
      weappTag.setAttribute('path', 'pages/yqj_v2/detail/main.html?id=3019527&parent2=mGDwEmnHQDJyj-ZSLECVTdfHSjQw4nY-SmviRc20O34&parent1=mGDwEmnHQDJyj-ZSLECVTdfHSjQw4nY-SmviRc20O34&did=250710204203906008&openview=&spmet=3367.3368.3375&et=share');

      // 设置内部模板内容
      const template = document.createElement('script');
      template.setAttribute('type', 'text/wxtag-template');

      template.innerHTML = `
        <style>
          .open-btn{
                  width: 200px;
                  height: 72px;
                   border: none;
                  text-align: center;
                  background: rgba(44,62,80,0);
                }
        </style>
        <button class="open-btn"></button>
      `;

      weappTag.appendChild(template);
      doc.appendChild(weappTag);

    },


    shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1)); // 生成一个从0到i的随机数
        [array[i], array[j]] = [array[j], array[i]]; // 交换元素
      }
      return array;
    },

    isAtBottom() {
      var scrollHeight = document.documentElement.scrollHeight;
      var clientHeight = window.innerHeight;
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop + clientHeight >= scrollHeight) {
        return true;
      } else {
        return false;
      }
    },

    jonUsScrollTo() {
      if (this.isAtBottom()) {
        // this.jonUs()
      } else {
        window.scrollTo({
          top: document.body.scrollHeight,
          behavior: 'smooth' // 平滑滚动效果
        });

      }
    },

    jonUs() {
      if (!this.isWeChatBrowser()) {
        this.$toast('请在手机微信中打开此链接');
      }
      // window.open('https://dipingxian-7ge5c47z13162111-1369584153.tcloudbaseapp.com/jump-mp.html', '_blank');
    },

    handleAnimation: function (anim) {
      this.anim = anim;

    },
    handleAnimation1: function (anim) {
      this.anim1 = anim;

    },
    loadWxSdk() {
      const script = document.createElement('script')
      script.src = 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js'
      const script1 = document.createElement('script')
      script1.src = 'https://res.wx.qq.com/open/js/jweixin-open-tag.js'
      document.head.appendChild(script)
      document.head.appendChild(script1)
    },

    closeVideo() {
      this.videoShow = false;
      this.videoShow1 = false;
    },

    openUrl() {
      window.open('https://beian.miit.gov.cn/#/Integrated/index', '_blank');
    },
    tabClick(index) {
      this.tabIndex = index;
    },
    seClick(index) {
      this.seIndex = index;
    },
  }
};
</script>

<style scoped lang="scss">
::-webkit-scrollbar {
  display: none;
}


@font-face {
  font-family: 'HappyZcool';
  src: url('@/assets/styles/HappyZcool.ttf') format('truetype');
}

.van-image-preview__close-icon {
  position: absolute;
  z-index: 1;
  color: #c8c9cc;
  font-size: 30px !important;
  cursor: pointer;
}

.van-swipe-item {
  text-align: left;
  position: relative;
  -webkit-flex-shrink: 0;
  flex-shrink: 0;
  width: 100%;
  height: 100%;
}


.h5-home-layout {
  .btn-layout {
    margin: 1rem 1rem 2rem;
    background: #3072c1;
    border-radius: 0.9rem;
    text-align: center;
    width: 7rem;
    height: 2rem;
    line-height: 2rem;
    color: #fff;
    font-size: 0.9rem;
  }

  .header {
    //background: #066FF2;
    margin: 0;
  }

  .header-icon {
    display: block;
    width: 100%;
    margin: 0;
    padding: 0;
  }

  .content {
    margin: 0;
    //padding-top: 0.25rem;

    .info-show-layout {
      position: relative;
      height: 23rem;
      background: rgba(48, 114, 193, 1);


      .van-swipe {
        height: 70px;
      }

      .donation-information-layout {
        position: absolute;
        z-index: 0;
        bottom: 0.5rem;
        padding-left: 10px;
        height: 80px;

        .donation-information-name {
          text-align: left;
          display: inline-block;
          background: rgba(0, 0, 0, 0.5);
          color: rgba(255, 255, 255, 1);
          border-radius: 10px;
          padding-top: 3px;
          padding-bottom: 3px;
          padding-left: 10px;
          padding-right: 10px;
          font-size: 0.8rem;

          .infos {
            padding-left: 10px;
          }
        }
      }

      .bg-cloud-layout-p {
        position: absolute;
        width: 100%;
        height: 23rem;
        z-index: 0;
        top: 0rem;

      }

      .bg-cloud-layout {
        position: relative;
        width: 100%;
        height: 100%;
        overflow: hidden;

        .cloud-syt1 {

        }

        .cloud {
          width: 13rem;
          position: absolute;
          animation-duration: 40s; /* 动画持续时间 */
          animation-timing-function: linear; /* 动画速度曲线 */
          animation-iteration-count: infinite; /* 动画无限次播放 */
        }

        /* 第一个白云的动画 */
        .cloud:nth-child(1) {
          top: 3%; /* 垂直位置 */
          left: 100%; /* 开始时在屏幕外 */
          animation-name: moveCloud1;
          animation-duration: 35s; /* 较快的动画速度 */
        }

        @keyframes moveCloud1 {
          from {
            left: 100%;
          }
          /* 开始位置 */
          to {
            left: -30%;
          }
          /* 结束位置 */
        }

        /* 第二个白云的动画 */
        .cloud:nth-child(2) {
          bottom: 30%; /* 垂直位置 */
          left: 100%; /* 开始时在屏幕外 */
          animation-name: moveCloud2;
          animation-duration: 22s; /* 较慢的动画速度 */
        }

        @keyframes moveCloud2 {
          from {
            left: 100%;
          }
          /* 开始位置 */
          to {
            left: -50%;
          }
          /* 结束位置 */
        }

        /* 第三个白云的动画 */
        .cloud:nth-child(3) {
          bottom: 5%; /* 垂直位置 */
          left: 100%; /* 开始时在屏幕外 */
          animation-name: moveCloud3;
          animation-duration: 50s; /* 较快的动画速度 */
        }

        @keyframes moveCloud3 {
          from {
            left: 100%;
          }
          /* 开始位置 */
          to {
            left: -40%;
          }
          /* 结束位置 */
        }

      }

      .info-show-layout-pro {
        display: flex;
        justify-content: center;
        align-items: center;

        .header_info-style {
          margin-top: 2rem;
          width: 50%;
        }
      }
    }

  }

  .swipe-layout {
    padding-bottom: 1.5rem;
  }

  .content-icon {
    width: 100%;
  }

  .section-title {
    padding-left: 1.5rem;
    padding-bottom: 1.5rem;
    text-align: left;
  }

  .section-title-img {
    height: 4rem;
  }

  .centered {
    display: flex;
    justify-content: center;
    text-align: center;
    width: 100%;

  }
  .open-stys{
    height: 4.5rem;
    width: 10rem;
    position: absolute;
    z-index: 100;
  }
  .anim-bg1{
    //position: absolute;
  }

  .open-btn{
    width: 250px;
    height: 60px;
    font-size: 18px;
    text-align: center;
    background: rgba(44,62,80,0);
  }

  .footer-link {
    display: flex;
    justify-content: center;
    text-align: center;
    flex-direction: column;
    width: 100%;
  }

  .footer-link {
    justify-content: center;
    margin-bottom: 2rem;

  }
}

.pc-home-layout {
  position: absolute;
  background: rgba(48, 114, 193, 1);
  width: 100%;
  height: 100vh;
  //background: url('@/assets/pc_bg.png') center/cover no-repeat;

  //display: flex;
  //justify-content: center;

  .pc-news-view {
    padding-left: 200px;
    padding-right: 200px;
    width: 600px;
    height: 80vh;
    overflow: scroll;
  }

  .bg-cloud-layout-p {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 0;
  }

  .bg-cloud-layout {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;

    .cloud {
      position: absolute;
      animation-duration: 40s; /* 动画持续时间 */
      animation-timing-function: linear; /* 动画速度曲线 */
      animation-iteration-count: infinite; /* 动画无限次播放 */
    }

    /* 第一个白云的动画 */
    .cloud:nth-child(1) {
      top: 5%; /* 垂直位置 */
      left: 100%; /* 开始时在屏幕外 */
      animation-name: moveCloud1;
      animation-duration: 30s; /* 较快的动画速度 */
    }

    @keyframes moveCloud1 {
      from {
        left: 100%;
      }
      /* 开始位置 */
      to {
        left: -30%;
      }
      /* 结束位置 */
    }

    /* 第二个白云的动画 */
    .cloud:nth-child(2) {
      top: 38%; /* 垂直位置 */
      left: 100%; /* 开始时在屏幕外 */
      animation-name: moveCloud2;
      animation-duration: 40s; /* 较慢的动画速度 */
    }

    @keyframes moveCloud2 {
      from {
        left: 100%;
      }
      /* 开始位置 */
      to {
        left: -50%;
      }
      /* 结束位置 */
    }

    /* 第三个白云的动画 */
    .cloud:nth-child(3) {
      top: 30%; /* 垂直位置 */
      left: 100%; /* 开始时在屏幕外 */
      animation-name: moveCloud3;
      animation-duration: 20s; /* 较快的动画速度 */
    }

    @keyframes moveCloud3 {
      from {
        left: 100%;
      }
      /* 开始位置 */
      to {
        left: -40%;
      }
      /* 结束位置 */
    }

  }


  .pc-content-layout {
    //max-width: 1280px;
    position: absolute;
    width: 100%;
    height: 100vh;
    z-index: 10;

    height: 100vh;

    .tab-layout {
      margin-top: 50px;
      display: flex;
      justify-content: center;
    }

    .tab-title-la {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .tab-temds {

      display: flex;
      font-family: 'HappyZcool';
      font-size: 20px;
      //background: rgba(255, 255, 255, 0.8);
      border-radius: 8px;
      align-items: center;
      justify-items: center;
      cursor: pointer;
      padding: 10px 25px;


      .tab-select-star {
        position: absolute;
        width: 20px;
        top: -25px;
        left: 35px;

      }

      .tab-items {

        padding: 6px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #ffffff;
      }

      .tab-items-s {

        padding: 6px;
        border-radius: 8px;
        color: #ffffff;
        background: rgba(249, 82, 105, 1);
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .lines {
        margin: 0 25px;
        width: 2px;
        height: 20px;
        background: #ffffff;
      }
    }

    .logo-image-layout-p {
      background: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;

    }

    .logo-image-layout {
      min-width: 1125px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 8px;


      .pc-logo-sty {
        //margin-top: 16px;
        height: 45px;
      }
    }

    .tab-content-layout {
      display: flex;
      justify-content: center;
      margin-top: 40px;

      .content-layout {
        width: 1125px;


        .news-view {
          background: #ffffff;
          //width: 1200px;
          //height: 615px;
          padding: 30px;
          height: 515px;
        }

        .new-list-layout {
          overflow: scroll;
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;

          .news-item-layout {
            position: relative;
            margin-top: 35px;

            .news-image {
              width: 310px;
              object-fit: cover;
              height: 210px;
            }

            .play-icon {
              position: absolute;
              top: 65px;
              left: 130px;
              width: 60px
            }

            .title {
              margin-top: 15px;
              color: rgba(35, 35, 35, 1);
              width: 310px;
              font-size: 16px;
              font-weight: bold;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
            }

            .del {
              margin-top: 15px;
              color: rgba(80, 80, 80, 1);
              font-size: 12px;
              width: 310px;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 4;
              overflow: hidden;
            }

          }
        }


        .co-layout {
          background: #fff;
          padding: 20px;
        }

        .time-layout {
          display: flex;

          .items {
            margin-right: 30px;
            font-size: 22px;
            font-weight: bold;
            color: #000;
            cursor: pointer;
          }

          .items-s {
            @extend .items;
            border-bottom: 2px solid #f95269;
            color: #f95269;
          }
        }

        .title-layout {
          display: flex;
          justify-content: space-between;
          margin-top: 30px;
          margin-bottom: 15px;

          .title {
            font-family: HappyZcool;
            font-weight: bold;
            font-size: 20px;
          }

          .time {
            font-size: 20px;
            font-weight: bold;
          }
        }

        .pc-tab-image {
          width: 1125px;
          background: #fff;
        }
      }
    }

    .footer-link.pc {
      margin-top: 15px;
      margin-right: 20px;
      color: #fff;
      cursor: pointer;
      justify-content: flex-end;
    }
  }
}
</style>
